<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 17:48:16
 * @LastEditTime: 2024-06-25 17:58:23
 * @LastEditors: 张天昊
 * @Description: 导游卡片
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/GuideCard.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import moment from 'moment';
import CardContainer from './CardContainer.vue';
import Description from './Description.vue';
import WithPhone from './WithPhone.vue';
import { useCardContainerEl } from '../composables/useCardContainerEl';
import { useAuth } from '../composables/useAuth';
import { dateStrFormat1, GuideConfirmStateType } from '../constants';
import {
  transformEnumValue2Label,
  genEmptyTextPlaceholder,
  formatPriceValue
} from '../utils';
import icGuideCard from '@/assets/itineraryUniversal/ic-guide-card.png';
import imgGuidePlaceholder from '@/assets/itineraryUniversal/guide-placeholder.png';

export default defineComponent({
  components: {
    CardContainer,
    Description,
    WithPhone
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { expose }) {
    const GuideConfirmStateTypeValue2Label = transformEnumValue2Label(
      GuideConfirmStateType
    );
    const { guideDetailAuth } = useAuth();
    const duration = computed(() => {
      const group = props.data.itineraryGuideMessageTimes;
      if (!group.length) {
        return '';
      }
      return group.reduce((prev, curr, index) => {
        const currStr = `${moment(curr.startDate).format(dateStrFormat1)} 至
          ${moment(curr.endDate).format(dateStrFormat1)}
          `;
        prev += currStr;
        return prev;
      }, '');
    });
    const { container } = useCardContainerEl();
    function onClick() {
      if (guideDetailAuth.value) {
        // 跳转导游详情页
        window.yyn.invokeJSB('openWindow', {
          openUrl: `${window.location.origin}/web/#/guide/info?guideId=${props.data.guideId}`,
          isFullScreen: 0,
          needLoading: 1
        });
      }
    }
    expose({
      // 里面的id对应站点导游列表的guideId
      bid: props.data.id,
      toggleHighlight: () => {
        if (container.value) {
          container.value.toggleHighlight();
        }
      }
    });
    return {
      icGuideCard,
      imgGuidePlaceholder,
      duration,
      container,
      GuideConfirmStateTypeValue2Label,
      guideDetailAuth,
      onClick,
      genEmptyTextPlaceholder,
      formatPriceValue
    };
  }
});
</script>

<template>
  <CardContainer ref="container" bordered @click="onClick">
    <div class="relative flex items-center">
      <van-image
        :width="$px2rem(48)"
        :height="$px2rem(48)"
        :error-icon="imgGuidePlaceholder"
        :src="data.photoPath || ''"
        class="flex-shrink-0 custom-avatar"
        fit="cover"
        round
      />
      <div class="ml-13">
        <div class="text-18 leading-24 font-semibold break-all">
          {{ data.name }}
        </div>
        <div class="mt-5 text-14 leading-20 text-black-b flex items-center">
          <img
            :src="icGuideCard"
            class="w-16 h-13 mr-6"
          />{{ data.certificate }}
        </div>
      </div>
      <span
        v-if="guideDetailAuth && data.guideId"
        class="absolute inline-flex items-center z-1 bottom-0 right-0 text-14 leading-22 font-semibold text-green-primary van-haptics-feedback"
        >导游详情<svg-icon
          pre-path="itineraryUniversal"
          name="ic-arrow"
          class="stroke-green-primary w-16 h-16"
      /></span>
    </div>
    <van-divider class="custom-divider" />
    <Description label="联系电话">
      <WithPhone :phone-number="data.phone" class="text-black-a" />
    </Description>
    <Description
      class="mt-8"
      label="带团时间"
      :content="genEmptyTextPlaceholder(duration)"
    />
    <Description
      class="mt-8"
      label="服务费"
      :content="formatPriceValue(data.referencePrice)"
    />
    <Description
      class="mt-8"
      label="确认状态"
      :content="GuideConfirmStateTypeValue2Label[`${data.confirm}`] || '未发送'"
    />
  </CardContainer>
</template>

<style lang="less" scoped>
@import '../styles/card-shared.css';
.custom-divider {
  margin: 14px 0 10px;
}
</style>
